import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { DownloadDelegate } from "./download.delegate";

export class DownloadService
{
    constructor(private downloadDelegate: DownloadDelegate)
    {
    }

    public getDocumentFile(filePath: string): any 
    {
        return this.downloadDelegate.getDownloadFile(filePath);
    }

    public getViewFileUrl(filePath: string): any
    {
        return this.downloadDelegate.getViewFileUrl(filePath);
    }
    public getAccessUrl(): any
    {
        return this.downloadDelegate.getQBAccessUrl();
    }
}